import { render, staticRenderFns } from "./RideitNoticesTable.vue?vue&type=template&id=79a77c34"
import script from "./RideitNoticesTable.vue?vue&type=script&lang=ts"
export * from "./RideitNoticesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports